<template>
  <el-drawer
    title="新增题目"
    :show-close="false"
    :wrapperClosable="false"
    :visible.sync="visible"
    direction="rtl"
    ref="drawer"
    class="drawer"
    size="50%"
  >
    <div class="demo-drawer__content">
      <el-tabs v-model="activeName" type="card">
        <el-tab-pane label="单选题" name="RADIO"> </el-tab-pane>
        <el-tab-pane label="多选题" name="CHECKBOX"></el-tab-pane>
        <el-tab-pane label="判断题" name="BOOLEAN"></el-tab-pane>
        <el-tab-pane label="填空题" name="SUPPLY"></el-tab-pane>
        <el-tab-pane label="简答题" name="ANSWER"></el-tab-pane>
      </el-tabs>
      <component
        :is="activeName"
        :ref="activeName"
        :form="form"
        :noScore="true"
        :isEdit="true"
      />
      <el-form size="small" label-width="70px">
        <el-form-item label="归属章节" prop="chapterId">
          <el-cascader
            v-model="form.chapterId"
            :options="chapterList"
            :props="{
              label: 'title',
              value: 'chapterId',
              emitPath: false,
            }"
            :show-all-levels="false"
            placeholder="请选择章节"
            clearable
          ></el-cascader>
          <!-- <el-select v-model="form.chapterId" placeholder="请选择章节">
            <el-option-group
              v-for="group in chapterList"
              :key="group.chapterId"
              :label="group.title"
            >
              <el-option
                v-for="item in group.children"
                :key="item.chapterId"
                :label="item.title"
                :value="item.chapterId"
              >
              </el-option>
            </el-option-group>
          </el-select> -->
        </el-form-item>
      </el-form>
      <div class="demo-drawer__footer">
        <el-button @click="cancelForm(false)" size="medium">取 消</el-button>
        <el-button type="primary" @click="handleClose(false)" size="medium"
          >提交</el-button
        >
        <el-button type="primary" @click="handleClose(true)" size="medium"
          >提交并新增下一题</el-button
        >
      </div>
    </div>
  </el-drawer>
</template>

<script>
import { addQuestion } from "@/api/questionBank";
import RADIO from "@/components/questionTemplate/radio";
import CHECKBOX from "@/components/questionTemplate/checkbox";
import BOOLEAN from "@/components/questionTemplate/boolean";
import SUPPLY from "@/components/questionTemplate/supply";
import ANSWER from "@/components/questionTemplate/answer";

export default {
  components: {
    RADIO,
    CHECKBOX,
    BOOLEAN,
    SUPPLY,
    ANSWER,
  },
  props: {
    chapterList: Array,
  },
  data() {
    return {
      activeName: "RADIO",
      questionId: null,
      visible: false,
      form: {
        type: "RADIO",
        question: "",
        optionList: [
          {
            tag: "A",
            option: "",
          },
          {
            tag: "B",
            option: "",
          },
          {
            tag: "C",
            option: "",
          },
        ],
        answerList: [],
        chapterId: null,
      },
    };
  },
  watch: {
    activeName(val) {
      if (val == "RADIO" || val == "CHECKBOX") {
        this.form = {
          type: val,
          question: "",
          optionList: [
            {
              tag: "A",
              option: "",
            },
            {
              tag: "B",
              option: "",
            },
            {
              tag: "C",
              option: "",
            },
          ],
          answerList: [],
          chapterId: null,
        };
      } else if (val == "BOOLEAN") {
        this.form = {
          type: val,
          question: "",
          optionList: [
            {
              tag: "A",
              option: "对",
            },
            {
              tag: "B",
              option: "错",
            },
          ],
          answerList: [],
          chapterId: null,
        };
      } else if (val == "SUPPLY") {
        this.form = {
          type: val,
          question: "",
          answerList: [],
          emptyCount: 1,
          chapterId: null,
        };
      } else if (val == "ANSWER") {
        this.form = {
          type: val,
          question: "",
          answerList: [],
          chapterId: null,
        };
      }
    },
  },
  methods: {
    async handleClose(next) {
      const valid = await this.$refs[this.activeName].$refs.form.validate();
      const optionValid = this.$refs[this.activeName].checkOption();

      if (valid && optionValid) {
        this.$confirm("确定要新增吗？", {
          type: "warning",
        })
          .then(() => {
            this.$refs[this.activeName].form.courseId =
              this.$route.query.courseId;
            this.$loading.show();
            addQuestion(this.$refs[this.activeName].form).then((res) => {
              if (res.code == 0) {
                this.$loading.hide();
                this.$message.success("保存成功");
                this.$emit("update");
                this.cancelForm(next);
              } else {
                this.$message.error(res.msg);
              }
            });
          })
          .catch(() => {});
      }
    },
    cancelForm(next) {
      if (!next) this.visible = false;

      this.activeName = this.$options.data().activeName;
      this.form = this.$options.data().form;
      // this.$refs.drawer.closeDrawer();
    },
  },
};
</script>

<style lang="less" scoped>
::v-deep .drawer {
  .el-drawer {
    padding: 20px;
    .el-drawer__header {
      margin-bottom: 20px;
      padding: 0;
      font-size: 16px;
      font-weight: bold;
    }
    .el-drawer__body {
      &::-webkit-scrollbar {
        width: 4px;
        background-color: #f5f5f5;
      }

      &::-webkit-scrollbar-track {
        box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
        border-radius: 10px;
        background-color: #f5f5f5;
      }

      &::-webkit-scrollbar-thumb {
        border-radius: 10px;
        box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
        background-color: #c8c8c8;
      }
    }
    .demo-drawer__footer {
      text-align: center;
    }
  }
}
</style>